import King from "./king";
import Knight from "./knight";
import Pawn from "./pawn";
import Queen from "./queen";

export type PieceType = "pawn" | "knight" | "queen" | "king";

export const PIECE_ORDER: PieceType[] = ["pawn", "knight", "queen", "king"];

export function PieceIcon({
    piece = "pawn",
    className,
}: {
    piece?: PieceType;
    className?: string;
}) {
    switch (piece) {
        case "knight":
            return <Knight className={className} />;
        case "queen":
            return <Queen className={className} />;
        case "king":
            return <King className={className} />;
        case "pawn":
        default:
            return <Pawn className={className} />;
    }
}
